var _style, _circle, _path, _g, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSadFaceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 383.3 383.3",
    style: {
      enableBackground: "new 0 0 383.3 383.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FED233;}\n\t.st1{fill:#808080;}\n\t.st2{fill:#4D1E1E;}\n\t.st3{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 191.7,
    cy: 191.7,
    r: 191.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.3,170C48.1,72.9,138.1,8,234.7,17.6c-4.3-1.2-8.7-2.4-13.2-3.3c-11.6-2.4-23.4-3.6-35.2-3.6 c-82.7,0-154.8,59-171.4,140.2c-9,43.9-1,88.6,22.4,126.6C24.6,244.4,20.7,207.4,28.3,170z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M113.9,206.3c-18.3-0.1-34.7-7.6-46.2-19.6c4.7,21.3,22.5,39.7,45.6,39.8c23.1,0.1,41-18.8,47-39.4 C148.7,199,132.2,206.4,113.9,206.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M269.3,206.2c-18.3,0-34.8-7.4-46.3-19.4c6.8,22.7,24.8,38.5,47.9,38.5c23.1,0,38.5-16.5,44.7-38.6 C304.1,198.7,287.6,206.2,269.3,206.2z"
  })))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M153,304.6c16.3-29.4,42.3-33.3,62.5-17.8c5.5,4.2,10.4,10.2,14.7,17.8c-4.5-2.3-8.9-4.9-13.4-6.8 c-5.2-2.2-10.5-3.7-15.8-4.4c-10.9-1.4-21.6-0.4-32.4,3.3C163.3,298.5,158.2,301.7,153,304.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.7,152.3c39.6,0,95.2-14.2,92.6-30.7C156.1,105.1,120.2,138.2,67.7,152.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M315.7,152.3c-39.6,0-95.2-14.2-92.6-30.7C227.3,105.1,263.2,138.2,315.7,152.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadFaceIcon);
export default __webpack_public_path__ + "static/media/sad_face_icon.46ff1a0c3a69095905039f637438eb29.svg";
export { ForwardRef as ReactComponent };